import { useState } from "react";

const faqData = [
  {
    question: "شو فيني أطلب من طبختنا؟",
    answer:
      "من طبختنا بتقدري تطلبي مكونات طبخة كاملة حسب رغبتك، أو وجبة جاهزة، ويتم تجهيز الطلب وتوصيله لباب البيت.",
  },
  {
    question: "هل يمكنني تحديد الكمية حسب عدد الأشخاص؟",
    answer:
      "نعم. حددي عدد الأشخاص ونحن نجهّز المكونات بالكميات المناسبة للطبخة المختارة.",
  },
  {
    question: "كيف بطلب وجبة جاهزة؟",
    answer:
      "اختاري الوجبة المناسبة، حددي الكمية، ثم أكملي الطلب ليتم توصيله إلى بابك.",
  },
  {
    question: "كيف بطلب مكونات طبخة؟",
    answer:
      "حددي الطبخة ثم عدد الأشخاص، وسنجهّز لك جميع المكونات بالكميات المناسبة.",
  },
  {
    question: "هل لازم اشترك بخطة شهرية؟",
    answer: "لا. يمكنك الطلب في أي وقت دون الحاجة إلى اشتراك شهري.",
  },
];

function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      itemScope
      itemType="https://schema.org/FAQPage"
      aria-labelledby="faq-heading"
      className="
        w-full
        bg-[#F8E6E3]
        px-5
        py-[70px]
        box-border
        flex
        justify-center
        rtl
        font-['Cairo']
        
        max-[600px]:px-4
        max-[600px]:py-[50px]
      "
    >
      <div
        className="
          w-full
          max-w-[900px]
          box-border
        "
      >
        <h2
          id="faq-heading"
          className="
            text-center
            font-extrabold
            text-[24px]
            leading-8
            tracking-[-0.2px]
            text-[#171717]
            m-0
            mb-[35px]

            max-[600px]:text-[20px]
            max-[600px]:mb-6
          "
        >
          كل شي بدك تعرفه عن طبختنا
        </h2>

        <div className="flex flex-col">
          {faqData.map((item, index) => {
            const isActive = activeIndex === index;

            return (
              <div
                key={index}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                className={`
                  border-b
                  border-[#d9d9d9]

                  ${index === faqData.length - 1 ? "border-b-0" : ""}
                `}
              >
                <button
                  type="button"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={isActive}
                  className="
                    w-full
                    bg-transparent
                    border-0
                    cursor-pointer
                    flex
                    items-center
                    justify-between
                    gap-4
                    rtl
                    text-right
                    p-[18px_0_10px]
                  "
                >
                  <span
                    itemProp="name"
                    className={`
                      font-['Cairo']
                      font-bold
                      text-base
                      leading-6
                      text-[#171717]
                      transition-transform
                      duration-300
                      ease-in-out

                      max-[600px]:text-sm

                      ${isActive ? "-translate-y-1" : "translate-y-0"}
                    `}
                  >
                    {item.question}
                  </span>

                  <span
                    className={`
                      shrink-0
                      w-5
                      h-5
                      flex
                      items-center
                      justify-center
                      text-[#9a9a9a]
                      transition-all
                      duration-300
                      ease-in-out

                      ${isActive ? "rotate-180 text-[#d32f2f]" : ""}
                    `}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 9L12 15L18 9"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>

                <div
                  className={`
                    grid
                    transition-[grid-template-rows]
                    duration-[350ms]
                    ease-in-out

                    ${isActive ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}
                  `}
                >
                  <div
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                    className="overflow-hidden"
                  >
                    <p
                      itemProp="text"
                      className="
                        m-0
                        text-[#3a3535]
                        text-sm
                        leading-6
                        text-right
                        pb-[18px]

                        max-[600px]:text-[13px]
                      "
                    >
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Faq;